import React from 'react'
import {
    PlusOutlined,
    WarningOutlined,
    StopOutlined,
    CheckCircleOutlined,
    EyeOutlined,
} from '@ant-design/icons'
import styled from 'styled-components'

import { StyledButton } from '../../Button'
import { useCaseViewContext } from '../../../context'

// Constants for case statuses and provider tags
const CaseStatusEnum = {
    CONSULT_COMPLETE: "consult complete",
    CONSULT_COMPLETE_NO_RX: "consult complete no rx",
    ADDITIONAL_INFO_REQUIRED: "additional info required",
    REFER: "refer"
}

const PhysicianTagEnum = {
    NEEDS_REVIEW: "needs review"
}

import { REQUEST_STATUS } from '../../../constants'

const Container = styled.div`
    display: flex;
    gap: 5px;
    align-items: flex-end;
    margin-top: 10px;
`

export const ProviderActions = ({
    showTreatmentModal,
    prescriptionQueue = {},
    onReviewAndSend,
    onAdditionalInfoRequired,
    onRefer,
    onConsultCompleteNoRx
}) => {
    const { 
        caseDetails, 
        activeRequest, 
        provider,
        apiType,
        readOnlyMode,
    } = useCaseViewContext()

    if (readOnlyMode && apiType === 'admin') {
        return null
    }

    const caseIsAlreadyCompleted = [
        CaseStatusEnum.CONSULT_COMPLETE, 
        CaseStatusEnum.CONSULT_COMPLETE_NO_RX
    ].includes(caseDetails?.status)
    
    const providerNeedsReview = provider?.tags?.includes(PhysicianTagEnum.NEEDS_REVIEW)
    const isMostRecentRequest = caseDetails?.requests?.at(-1)?._id === activeRequest?._id   
    
    const hide = readOnlyMode ||
        !isMostRecentRequest || 
        (providerNeedsReview && caseDetails?.status === CaseStatusEnum.REFER)
    
    if (hide) {
        return null
    }

    const handleReviewAndSend = () => {
        if (onReviewAndSend) {
            onReviewAndSend()
        }
    }

    const setStatusToAdditionalInfoRequired = () => {
        if (onAdditionalInfoRequired) {
            onAdditionalInfoRequired()
        }
    }

    const setStatusToRefer = () => {
        if (onRefer) {
            onRefer()
        }
    }

    const setStatusToConsultCompleteNoRx = () => {
        if (onConsultCompleteNoRx) {
            onConsultCompleteNoRx()
        }
    }

    return (
        <Container>
            <StyledButton 
                id="treatment-add-treatment-btn"
                tooltip="Add a treatment" 
                Icon={PlusOutlined} 
                borderColor="#7BAD7E" 
                textColor="#7BAD7E" 
                color="white" 
                onClick={showTreatmentModal}
            />
            { 
                !caseIsAlreadyCompleted && (
                    <StyledButton 
                        id="treatment-additional-info-btn"
                        Icon={WarningOutlined}
                        tooltip='Additional Info Requested'
                        color="orange" 
                        onClick={setStatusToAdditionalInfoRequired}
                    />
                )
            }
            { 
                !caseIsAlreadyCompleted && 
                providerNeedsReview && (
                    <StyledButton 
                        id="treatment-needs-review-btn"
                        Icon={EyeOutlined} 
                        color="red"
                        tooltip='Needs Review'
                        onClick={setStatusToRefer}
                    /> 
                ) 
            }
            { 
                !providerNeedsReview && activeRequest?.status !== REQUEST_STATUS.COMPLETED_NO_RX && (
                    <StyledButton 
                        id="treatment-consult-complete-no-rx-btn"
                        Icon={StopOutlined} 
                        color="red"
                        tooltip='Consult Complete, No Rx'
                        onClick={setStatusToConsultCompleteNoRx}
                    /> 
                )
            }
            { 
                (Object.values(prescriptionQueue || {})).length > 0 && (

                    <StyledButton
                        id="treatment-review-and-send-btn"
                        tooltip='Consult Complete, Prescribe'
                        Icon={CheckCircleOutlined} 
                        onClick={handleReviewAndSend}
                    />
                )
            }
        </Container>
    )
}
